import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import * as DataService from "../util/DataService";
import Tooltip from "@material-ui/core/Tooltip";

import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import CircularProgress from "@mui/material/CircularProgress";
import DialogContentText from "@mui/material/DialogContentText";
import Button from "@mui/material/Button";
import ConventionMap from "../convention-map/ConventionMap";
import { Calendar } from "@fullcalendar/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import moment from "moment";
import "./ConventionSchedule.css";

import { DataGrid, GridRowsProp, GridColDef } from "@mui/x-data-grid";

//divide event into 15  minute blocks, count the amount of blocks

const useStyles = makeStyles({
  dialog_container: {
    "border-radius": "25px",
    "max-width": "700px",
    overflow: "hidden",
  },
});

const ConventionScheduleOldLib = (props) => {
  const [conventionWeek, setConventionWeek] = useState([
    { conventionRooms: [], header: [] },
  ]);

  const classes = useStyles();
  const [openInfoPanel, setOpenInfoPanel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [conStart, setConStart] = useState(0);
  const [calendar, setCalendar] = useState();
  const [buttonList, setButtonList] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState({
    details: { details: "" },
  });
  //   const [rooms, setRooms] = useState(fakeRooms);
  const weekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Map",
  ];

  const { onClose, selectedValue, open } = props;

  const handleClose = (value) => {
    setOpenInfoPanel(false);
  };

  const buildTableResources = (data) => {
    console.log("DATA");
    console.log(data);


    let resources = [];

    for (let iter = 0; iter < data.rooms.length; iter++) {
      let newResource = {
        id: data.rooms[iter].id,
        title: data.rooms[iter].name,
      };
      resources.push(newResource);
    }

    let events = [];
    let scheduleEvents = data.schedules[0].scheduleEvents;

    for (let iter = 0; iter < scheduleEvents.length; iter++) {
      //get event details
      let eventDetails = {};

      for (
        let detailIter = 0;
        detailIter < data.activities.length;
        detailIter++
      ) {
        if (data.activities[detailIter].id == scheduleEvents[iter].eventId) {
          eventDetails = data.activities[detailIter];
        }
      }

      let newEvent = {
        id: scheduleEvents[iter].id,
        title: eventDetails.name,
        resourceId: scheduleEvents[iter].roomId,
        start: new Date(scheduleEvents[iter].startDate),
        end: new Date(scheduleEvents[iter].endDate),
        // start: scheduleEvents[iter].startDate,
        // end: scheduleEvents[iter].endDate,
        eventName: eventDetails.name,
        hostName: eventDetails.hostName,
        description: eventDetails.description,
        color: eventDetails.colorCode,
        examine_color: eventDetails.colorCode,
      };

      events.push(newEvent);
    }

    console.log("EVNETS CHECK");
    console.log(events);
    let buttons = buildTableButtons(events);
    buildCalendarButtons(events);
    let calendarEl = document.getElementById("calendar");
    let newCalendar = new Calendar(calendarEl, {
      eventClick: function (info) {
        var eventObj = info.event;
        setSelectedEvent(eventObj._def.extendedProps);
        setOpenInfoPanel(true);

        if (eventObj.url) {
          info.jsEvent.preventDefault(); // prevents browser from following link in current tab.
        } else {
          // alert("Clicked " + eventObj.title);
        }
      },

      schedulerLicenseKey: "CC-Attribution-NonCommercial-NoDerivatives",
      plugins: [resourceTimelinePlugin],
      initialView: "resourceTimeline",
      initialDate: data.startDate,
      resources: resources,
      slotMinWidth: 70,
      resourceAreaWidth: 170,
      resourceAreaColumns: [
        {
          // group: true,
          // field: "building",
          headerContent: "Rooms",
        },
      ],
      nextDayThreshold: "03:00:00",
      // timeZone: "GMT-8",
      events: events,
      // slotMinTime: getEarliestHour(events),
      // slotMaxTime: getLatestHour(events),
      slotMinTime: "10:00:00",
      slotMaxTime: "28:00:00",
      height: "auto",
      // expandRows:true,
      // customButtons: buttons,
      headerToolbar: {
        left: "",
        center: "",
        right: "",
      },
    });
    setCalendar(newCalendar);
    setLoading(false);
    newCalendar.render();
  };

  const getEarliestHour = (events) => {
    let earliestHour = "24";

    for (let iter = 0; iter < events.length; iter++) {
      if (events[iter].start.getHours() < earliestHour) {
        earliestHour = events[iter].start.getHours();
        if (earliestHour < "6") {
          return earliestHour;
        }
      }
    }

    return earliestHour;
  };

  const getLatestHour = (events) => {
    let latestHour = 0;

    for (let iter = 0; iter < events.length; iter++) {
      console.log(events[iter].start.getHours());
      if (events[iter].start.getHours() > latestHour) {
        latestHour = events[iter].start.getHours();
      }
    }

    return latestHour + 3 + ":00:00";
  };

  const setDate = (date) => {
    console.log("DATE");
    console.log(date);
    calendar.gotoDate(date);
  };
  const buildCalendarButtons = (events) => {
    let dayNames = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    let implementedButtons = [];
    for (let iter = 0; iter < events.length; iter++) {
      console.log("CHECK");
      let newButton = {
        name: dayNames[events[iter].start.getDay()],
        date: events[iter].start,
      };
      if (
        !doesDayAlreadyHaveAButton(implementedButtons, newButton.name) &&
        events[iter].start.getHours() > "10"
      ) {
        implementedButtons.push(newButton);
      }
    }
    console.log("IMPLEMENTED BUTTONS");
    console.log(implementedButtons);
    setButtonList(implementedButtons);
  };
  const doesDayAlreadyHaveAButton = (buttonList, day) => {
    for (let iter = 0; iter < buttonList.length; iter++) {
      if (buttonList[iter].name === day) {
        return true;
      }
    }
    return false;
  };

  const buildTableButtons = (events) => {
    let buttons = [];
    let dayNames = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    let newButtons = {};

    console.log("EVENTS");
    console.log(events);
    for (let iter = 0; iter < events.length; iter++) {
      newButtons[dayNames[events[iter].start.getDay()]] = {
        text: dayNames[events[iter].start.getDay()],
        click: function () {
          setDate(events[iter].start);
        },
      };
    }
    console.log("BUTTONS");
    console.log(newButtons);
    return newButtons;
  };

  const LightenDarkenColor = (col, amt) => {
    let usePound = false;

    if (col[0] == "#") {
      col = col.slice(1);
      usePound = true;
    }

    let num = parseInt(col, 16);

    let r = (num >> 16) + amt;

    if (r > 255) r = 255;
    else if (r < 0) r = 0;

    let b = ((num >> 8) & 0x00ff) + amt;

    if (b > 255) b = 255;
    else if (b < 0) b = 0;

    let g = (num & 0x0000ff) + amt;

    if (g > 255) g = 255;
    else if (g < 0) g = 0;

    return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
  };

  useEffect(() => {
    setLoading(true);
    fetch(
      "https://codeimp-conventionservice-dev.azurewebsites.net/api/public/GetPublicConventionEvent?shortName=Test2022"
    )
      .then((response) => response.json())
      .then((data) => buildTableResources(data));
    // setRooms(fakeRooms);
  }, []);

  return (
    <div id="schedule-container">
      {loading && <CircularProgress />}

      <div className="button-container">
        {buttonList.map((button, index) => (
          <div className="date-button">
            <Button
              variant="contained"
              className="date-button"
              onClick={() => setDate(button.date)}
            >
              {button.name}
            </Button>
          </div>
        ))}
      </div>
      <div id="calendar"></div>

      <Dialog
        classes={{
          paper: classes.dialog_container,
        }}
        id="dialog-box"
        fullWidth={true}
        maxWidth={"lg"}
        onClose={handleClose}
        open={openInfoPanel}
      >
        <div
          id="event-details-title"
          style={{
            "background-color": selectedEvent.examine_color,
            color: "white",
          }}
        >
          {selectedEvent.eventName}{" "}
          <FontAwesomeIcon
            className="fa-icon"
            icon={faTimes}
            size="lg"
            onClick={handleClose}
          />
        </div>
        <div>
          <DialogContent
            id="event-details-content-container"
            style={{
              "background-color": LightenDarkenColor(
                selectedEvent.examine_color || "white",
                190
              ),
            }}
          >
            <DialogContentText id="alert-dialog-description">
              <div id="description-conatiner">
                {selectedEvent.hostName && (
                  <h3>Hosted by: {selectedEvent.hostName}</h3>
                )}

                {selectedEvent.description}
              </div>
              <div id="contact-container">
                {selectedEvent.hostName && (
                  <div>
                    <div>Contact</div>
                    <div> {selectedEvent.hostName}</div>
                  </div>
                )}
              </div>
            </DialogContentText>
          </DialogContent>

          <div></div>
        </div>
      </Dialog>
    </div>
  );
};
export default ConventionScheduleOldLib;
